import { useState } from "react";
import { createPortal } from "react-dom";
import './Gallery.css';

const Gallery = ({ imageInfos, height="100%", style }) => {
	const defaultHeight = 30; // vh
	const parseHeight = (value) => {
		if (typeof value === "string" && value.endsWith("%")) {
			const percent = parseFloat(value) / 100;
			return `${defaultHeight * percent}vh`;
		}
		// fallback to allow explicit heights like "40vh" or "300px"
		return value;
	};
	const computedHeight = parseHeight(height);

	let [selectedImageInfo, setSelectedImageInfo] = useState(null);
	const totalWidth = imageInfos.reduce((sum, imageInfo) => sum + imageInfo.width, 0);

	const handleImageClick = (imageInfo) => {
		setSelectedImageInfo(imageInfo);
	};

	const closeOverlay = () => {
		setSelectedImageInfo(null);
	};

	const overlay = selectedImageInfo && (
		<div className="imageOverlay" onClick={closeOverlay}>
			<div className="overlayContent" onClick={(e) => e.stopPropagation()}>
				{selectedImageInfo.image}
			</div>
		</div>
	);

	// The order on `height: computedHeight, ...style` matters so the passed in styles can overwrite the calculated height
	return (
		<div className="gallery" style={{ height: computedHeight, ...style }}>
			{imageInfos.map((imageInfo, index) => (
				<div key={index} className="galleryColumn" style={{ width: `${(imageInfo.width / totalWidth).toFixed(2) * 100}%`, height: '100%', overflow: 'hidden' }}>
					<div className="imgHoverOutline" style={{ width: '100%', height: '100%' }}></div>
					<div className="imgWrapper" style={{ aspectRatio: `${imageInfo.width} / ${imageInfo.height}`, width: '100%', height: '100%' }}
							onClick={() => handleImageClick(imageInfo)}>{imageInfo.image}</div>
				</div>
			))}
			{/* Overlay must be appended at the page-level and not bound within some other element */}
			{typeof document !== 'undefined' && overlay ? createPortal(overlay, document.body) : null}
		</div>
	);
};

export default Gallery;
